import ApiCall from "../constants/Api";
import SiteConfig from "../constants/SiteConfig";
import { helpAxios } from "../helpers/helpAxios";
import { errorHandler } from "../components/ErrorHandler";

export const useUpdateFunctions = () => {
  //Call method saverace
  const updateRaceInfo = async (request, LogonSessionID) => {
    let response;
    try {
      response = await helpAxios(
        SiteConfig.RACING_INTEGRATION_SVC,
        ApiCall.UPDATE_RACE,
        {
          ...request,
        },
        LogonSessionID
      );
      // Show error message
      if (response.error) {
        errorHandler(response.error, response.errorDetails);
      }
    } catch (error) {
      errorHandler(error.toString());
    }
    return response;
  };

  //Call method saveentry
  const updateEntriesInfo = async (request, LogonSessionID) => {
    let response;
    try {
      response = await helpAxios(
        SiteConfig.RACING_INTEGRATION_SVC,
        ApiCall.UPDATE_ENTRIES,
        {
          ...request,
        },
        LogonSessionID
      );
      // Show error message
      if (response.error) {
        errorHandler(response.error, response.errorDetails);
      }
    } catch (error) {
      errorHandler(error.toString());
    }
    return response;
  };

  //Call method saveresults
  const updateResultsInfo = async (request, LogonSessionID) => {
    let response;
    try {
      response = await helpAxios(
        SiteConfig.RACING_INTEGRATION_SVC,
        ApiCall.UPDATE_RESULTS,
        {
          ...request,
        },
        LogonSessionID
      );
      // Show error message
      if (response.error) {
        errorHandler(response.error, response.errorDetails);
      }
    } catch (error) {
      errorHandler(error.toString());
    }
    return response;
  };

  //Call method setstatus
  const updateStatus = async (request, LogonSessionID) => {
    let response;
    try {
      response = await helpAxios(
        SiteConfig.RACING_INTEGRATION_SVC,
        ApiCall.SET_STATUS,
        {
          ...request,
        },
        LogonSessionID
      );
      // Show error message
      if (response.error) {
        errorHandler(response.error, response.errorDetails);
      }
    } catch (error) {
      errorHandler(error.toString());
    }
    return response;
  };

  //Call method UpdateTrack
  const updateTracks = async (request, LogonSessionID) => {
    let response;
    try {
      response = await helpAxios(
        SiteConfig.RACING_MGMT_SVC,
        ApiCall.UPDATE_TRACKS,
        {
          ...request,
        },
        LogonSessionID
      );
      // Show error message
      if (response.error) {
        errorHandler(response.error, response.errorDetails);
      }
    } catch (error) {
      errorHandler(error.toString());
    }
    return response;
  };

  //Call method UpdateTrackCategory
  const updateTrackCategory = async (request, LogonSessionID) => {
    let response;
    try {
      response = await helpAxios(
        SiteConfig.RACING_MGMT_SVC,
        ApiCall.UPDATE_TRACK_CATEGORY,
        {
          ...request,
        },
        LogonSessionID
      );
      // Show error message
      if (response.error) {
        errorHandler(response.error, response.errorDetails);
      }
    } catch (error) {
      errorHandler(error.toString());
    }
    return response;
  };

  //Call method UpdateTrackAltCategory
  const updateTrackAltCategory = async (request, LogonSessionID) => {
    let response;
    try {
      response = await helpAxios(
        SiteConfig.RACING_MGMT_SVC,
        ApiCall.UPDATE_TRACK_ALT_CATEGORY,
        {
          ...request,
        },
        LogonSessionID
      );
      // Show error message
      if (response.error) {
        errorHandler(response.error, response.errorDetails);
      }
    } catch (error) {
      errorHandler(error.toString());
    }
    return response;
  };

  //Call method UpdateSystemPreferencesRacing
  const updateSystemPreferencesRacing = async (request, LogonSessionID) => {
    let response;
    try {
      response = await helpAxios(
        SiteConfig.RACING_MGMT_SVC,
        ApiCall.UPDATE_SYSTEM_PREFERENCES_RACING,
        {
          ...request,
        },
        LogonSessionID
      );
      // Show error message
      if (response.error) {
        errorHandler(response.error, response.errorDetails);
      }
    } catch (error) {
      errorHandler(error.toString());
    }
    return response;
  };

  //Call method OnlineResetUserPassword
  const resetUserPassword = async (request, LogonSessionID) => {
    let response;
    try {
      response = await helpAxios(
        "",
        ApiCall.ONLINE_RESET_USER_PASSWORD,
        {
          ...request,
        },
        LogonSessionID
      );
      // Show error message
      if (response.error) {
        errorHandler(response.error, response.errorDetails);
      }
    } catch (error) {
      errorHandler(error.toString());
    }
    return response;
  };

  //Call method score
  const score = async (request, LogonSessionID) => {
    let response;
    try {
      response = await helpAxios(
        SiteConfig.RACING_SCORING_SVC,
        ApiCall.SCORE,
        {
          ...request,
        },
        LogonSessionID
      );
      // Show error message
      if (response.error) {
        errorHandler(response.error, response.errorDetails);
      }
    } catch (error) {
      errorHandler(error.toString());
    }
    return response;
  };

  //Call method unscore
  const unscore = async (request, LogonSessionID) => {
    let response;
    try {
      response = await helpAxios(
        SiteConfig.RACING_SCORING_SVC,
        ApiCall.UNSCORE,
        {
          ...request,
        },
        LogonSessionID
      );
      // Show error message
      if (response.error) {
        errorHandler(response.error, response.errorDetails);
      }
    } catch (error) {
      errorHandler(error.toString());
    }
    return response;
  };

  //Call method ticketvoidlist
  const ticketVoidList = async (request, LogonSessionID) => {
    let response;
    try {
      response = await helpAxios(
        SiteConfig.RACING_TICKET_VALIDATOR_SVC,
        ApiCall.TICKET_VOID_LIST,
        {
          ...request,
        },
        LogonSessionID
      );
      // Show error message
      if (response.error) {
        errorHandler(response.error, response.errorDetails);
      }
    } catch (error) {
      errorHandler(error.toString());
    }
    return response;
  };

  //Call method scoreticketlist
  const scoreTicketList = async (request, LogonSessionID) => {
    let response;
    try {
      response = await helpAxios(
        SiteConfig.RACING_SCORING_SVC,
        ApiCall.SCORE_TICKET_LIST,
        {
          ...request,
        },
        LogonSessionID
      );
      // Show error message
      if (response.error) {
        errorHandler(response.error, response.errorDetails);
      }
    } catch (error) {
      errorHandler(error.toString());
    }
    return response;
  };

  //Call method rebatestickets
  const payRebatesTickets = async (request, LogonSessionID) => {
    let response;
    try {
      response = await helpAxios(
        SiteConfig.RACING_INTEGRATION_SVC,
        ApiCall.PAY_REBATES,
        {
          ...request,
        },
        LogonSessionID
      );
      // Show error message
      if (response.error) {
        errorHandler(response.error, response.errorDetails);
      }
    } catch (error) {
      errorHandler(error.toString());
    }
    return response;
  };

  //Call method ticketvoid
  const ticketVoid = async (request, LogonSessionID) => {
    let response;
    try {
      response = await helpAxios(
        SiteConfig.RACING_TICKET_VALIDATOR_SVC,
        ApiCall.VOID,
        {
          ...request,
        },
        LogonSessionID
      );
      // Show error message
      if (response.error) {
        errorHandler(response.error, response.errorDetails);
      }
    } catch (error) {
      errorHandler(error.toString());
    }
    return response;
  };

  return {
    updateRaceInfo,
    updateEntriesInfo,
    updateResultsInfo,
    updateStatus,
    updateTracks,
    updateTrackCategory,
    updateTrackAltCategory,
    updateSystemPreferencesRacing,
    resetUserPassword,
    score,
    unscore,
    ticketVoidList,
    scoreTicketList,
    payRebatesTickets,
    ticketVoid,
  };
};
